// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"5a0bf08d","119":"1cbc52ef","453":"b98e44ac","457":"d39ca106"}[chunkId] + ".chunk.js";
};